<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .search-container {
    width: 100%;

    input[type="search"] {
      width: 100%;
      padding: utils.in_rem(8px) utils.in_rem(12px);
      border: 1px solid colors.get(interfaceSwGrey_10);
      border-radius: 8px;
      @include mixins.body2();

      &:focus {
        outline: none;
        border-color: colors.get(interfaceBrandSurfaceDark);
      }

      &::placeholder {
        color: colors.get(textGrey);
      }

      &::-webkit-search-cancel-button {
        cursor: pointer;
      }
    }
  }
</style>

<script>
  export let value = "";
</script>

<div class="search-container">
  <input type="search" bind:value placeholder="Search" />
</div>
